// ./src/contexts/VenuesContext/VenuesContext.tsx
//
// Thin context wrapper around the useVenues hook. All derived data lives in the
// hook itself. See HighlightsContext for the pattern.

import React, { createContext, useContext } from "react";

import { useVenues, UseVenuesOptions, UseVenuesReturn } from "@/hooks/useVenues";

const VenuesContext = createContext<UseVenuesReturn | null>(null);

export interface VenuesProviderProps extends UseVenuesOptions {
  children: React.ReactNode;
}

export const VenuesProvider: React.FC<VenuesProviderProps> = ({ children, ...options }) => {
  const value = useVenues(options);

  return <VenuesContext.Provider value={value}>{children}</VenuesContext.Provider>;
};

export const useVenuesContext = (): UseVenuesReturn => {
  const context = useContext(VenuesContext);

  if (!context) {
    throw new Error(
      "useVenuesContext must be used within a <VenuesProvider>. " +
        "Wrap your component tree with <VenuesProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalVenuesContext = (): UseVenuesReturn | null => {
  return useContext(VenuesContext);
};
